import { getMockAggregatedStatistics } from "../demo/mockHomeMonitoring";
import {
  getMockGroupSummaryStatisticsAggregated,
  getMockGroupSummaryStatisticsAggregatedAge,
  getMockSummaryStatisticsAggregated,
  getMockSummaryStatisticsAggregatedAge,
} from "../demo/mockPlayerStatistics";

const emptyApiResponse = {
  data: {
    StatusCode: 200,
    Data: {
      Items: [],
      TotalCount: 0,
      Permissions: [],
      AcademyMerchantRegistrationStatus: 2,
    },
  },
};

const monitoringUrls = [
  "/api/StatisticsProcessor/GetAggregatedStatisticsByAcademyId",
  "/api/StatisticsProcessor/GetAggregatedStatisticsByGroupId",
];

const statisticsUrls: Record<string, (body?: any) => Promise<unknown>> = {
  "/statisticsprocessor/SummaryStatistics/Aggregated": getMockSummaryStatisticsAggregated,
  "/statisticsprocessor/SummaryStatistics/Aggregated/Age": getMockSummaryStatisticsAggregatedAge,
  "/statisticsprocessor/SummaryStatistics/Group/Aggregated": getMockGroupSummaryStatisticsAggregated,
  "/statisticsprocessor/SummaryStatistics/Group/Aggregated/Age":
    getMockGroupSummaryStatisticsAggregatedAge,
};

const resolveUrl = (url?: string) => {
  if (!url) {
    return "";
  }
  const normalized = url.split("?")[0];
  const path = normalized.replace(/^https?:\/\/[^/]+/i, "");
  return path.startsWith("/") ? path : `/${path}`;
};

const request = async (url?: string, body?: any, _config?: any) => {
  const path = resolveUrl(url);
  if (monitoringUrls.includes(path)) {
    const payload = await getMockAggregatedStatistics(body ?? {});
    return { data: payload };
  }
  if (statisticsUrls[path]) {
    const payload = await statisticsUrls[path](body ?? {});
    return { data: payload };
  }
  return emptyApiResponse;
};

const api: any = {
  get: request,
  post: request,
  put: request,
  patch: request,
  delete: request,
  interceptors: {
    request: { use: () => 0, eject: () => {} },
    response: { use: () => 0, eject: () => {} },
  },
  defaults: { headers: { common: {} } },
};

export default api;
